<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      router-link(:to="{name:'federation-vehicles', params:{id:item.id}}") Vehicles
      router-link(:to="{name:'federation-parking-groups', params:{id:item.id}}") Parking groups
      router-link(:to="{name:'federation-clients', params:{id:item.id}}") Clients
      ActionButton(:action="remove", :confirm="true") Delete

</template>

<script>
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'

  export default {
    name: 'FederationButtons',
    components: {ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.federations.select(this.item).remove(() => {
          MaggieHelper.notification('Federation', 'Federation deleted')
          this.$emit('itemUpdated')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FederationButtons.vue?88d6c044